if (!customElements.get('popout-select')) {
  customElements.define(
    'popout-select',
    class Popout extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.popoutList = this.querySelector('[data-popout-list]');
        this.popoutToggle = this.querySelector('[data-popout-toggle]');
        this.popoutToggleText = this.querySelector('[data-popout-toggle-text]');
        this.popoutInput = this.querySelector('[data-popout-input]') || this.parentNode.querySelector('[data-popout-input]') || this.parentNode.parentNode.querySelector('[data-quantity-input]');

        this.popoutOptions = this.querySelectorAll('[data-popout-option]');
        this.productGridItem = this.popoutList.closest('[data-grid-item]');
        this.fireSubmitEvent = this.hasAttribute('submit');

        this.popupToggleFocusoutEvent = (evt) => this.onPopupToggleFocusout(evt);
        this.popupListFocusoutEvent = (evt) => this.onPopupListFocusout(evt);
        this.popupToggleClickEvent = (evt) => this.onPopupToggleClick(evt);
        this.keyUpEvent = (evt) => this.onKeyUp(evt);
        this.bodyClickEvent = (evt) => this.onBodyClick(evt);

        this._connectOptions();
        this._connectToggle();
        this._onFocusOut();
      }

      onPopupToggleClick(evt) {
        const button = evt.currentTarget;
        const ariaExpanded = button.getAttribute('aria-expanded') === 'true';

        if (this.productGridItem) {
          const productGridItemImage = this.productGridItem.querySelector('[data-product-image]');

          if (productGridItemImage) {
            productGridItemImage.classList.toggle('is-visible', !ariaExpanded);
          }

          this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom - this.productGridItem.getBoundingClientRect().bottom)}px`;
        }

        this.popoutList.classList.toggle('popout-list--visible');
        button.setAttribute('aria-expanded', !ariaExpanded);

        if (!ariaExpanded) {
          this.toggleListPosition();
          this.popupListSetDimensions();
        } else {
          this._hideList();
        }

        document.body.addEventListener('click', this.bodyClickEvent);
      }

      onPopupToggleFocusout(evt) {
        const popoutLostFocus = this.contains(evt.relatedTarget);

        if (!popoutLostFocus) {
          this._hideList();
        }
      }

      onPopupListFocusout(evt) {
        const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
        const isVisible = this.popoutList.classList.contains('popout-list--visible');

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      }

      toggleListPosition() {
        const popoutToggleTop = this.popoutToggle.getBoundingClientRect().top;

        if (theme.windowHeight / 2 < popoutToggleTop) {
          this.popoutList.classList.add('popout-list--top');
        }
      }

      popupListSetDimensions() {
        this.popoutList.style.setProperty('--max-width', '100vw');
        this.popoutList.style.setProperty('--max-height', '100vh');

        requestAnimationFrame(() => {
          const listRect = this.popoutList.getBoundingClientRect();
          const toggleRect = this.popoutToggle.getBoundingClientRect();

          const distanceToRight = theme.windowWidth - listRect.left;
          const distanceToBottom = theme.windowHeight - toggleRect.bottom;
          const distanceToTop = toggleRect.top;

          const opensUp = this.popoutList.classList.contains('popout-list--top');
          const maxHeight = opensUp ? distanceToTop : distanceToBottom;

          this.popoutList.style.setProperty('--max-width', `${Math.floor(distanceToRight)}px`);
          this.popoutList.style.setProperty('--max-height', `${Math.floor(maxHeight)}px`);
        });
      }

      popupOptionsClick(evt) {
        const link = evt.target.closest('[data-popout-option]');

        if (link.attributes.href.value === '#') {
          evt.preventDefault();

          const attrValue = evt.currentTarget.hasAttribute('data-value') ? evt.currentTarget.getAttribute('data-value') : '';

          this.popoutInput.value = attrValue;

          // Sync option metadata onto the hidden input so downstream logic can read it
          const listItem = evt.currentTarget.closest('li');
          if (listItem) {
            const optionValueId = listItem.getAttribute('data-option-value-id');
            const productUrl = listItem.getAttribute('data-product-url');
            if (optionValueId) this.popoutInput.setAttribute('data-option-value-id', optionValueId);
            if (productUrl) this.popoutInput.setAttribute('data-product-url', productUrl);
          }

          if (this.popoutInput.disabled) {
            this.popoutInput.removeAttribute('disabled');
          }

          if (this.fireSubmitEvent) {
            this._submitForm(attrValue);
          } else {
            const currentTarget = evt.currentTarget.parentElement;
            const listTargetElement = this.popoutList.querySelector('.is-active');
            const targetAttribute = this.popoutList.querySelector('[aria-current]');

            // Fire a bubbling change event so parent controllers can react
            this.popoutInput.dispatchEvent(new Event('change', { bubbles: true }));

            if (listTargetElement) {
              listTargetElement.classList.remove('is-active');
              currentTarget.classList.add('is-active');
            }

            if (this.popoutInput.name == 'quantity' && !currentTarget.nextSibling) {
              this.classList.add('is-active');
            }

            if (targetAttribute && targetAttribute.hasAttribute('aria-current')) {
              targetAttribute.removeAttribute('aria-current');
              evt.currentTarget.setAttribute('aria-current', 'true');
            }

            if (attrValue !== '') {
              this.popoutToggleText.innerHTML = attrValue;

              if (this.popoutToggleText.hasAttribute('data-popout-toggle-text') && this.popoutToggleText.getAttribute('data-popout-toggle-text') !== '') {
                this.popoutToggleText.setAttribute('data-popout-toggle-text', attrValue);
              }
            }
            this.onPopupToggleFocusout(evt);
            this.onPopupListFocusout(evt);
          }
        }
      }

      onKeyUp(evt) {
        if (evt.code !== 'Escape') {
          return;
        }
        this._hideList();
        this.popoutToggle.focus();
      }

      onBodyClick(evt) {
        const isOption = this.contains(evt.target);
        const isVisible = this.popoutList.classList.contains('popout-list--visible');

        if (isVisible && !isOption) {
          this._hideList();
        }
      }

      _connectToggle() {
        this.popoutToggle.addEventListener('click', this.popupToggleClickEvent);
      }

      _connectOptions() {
        if (this.popoutOptions.length) {
          this.popoutOptions.forEach((element) => {
            element.addEventListener('click', (evt) => this.popupOptionsClick(evt));
          });
        }
      }

      _onFocusOut() {
        this.addEventListener('keyup', this.keyUpEvent);
        this.popoutToggle.addEventListener('focusout', this.popupToggleFocusoutEvent);
        this.popoutList.addEventListener('focusout', this.popupListFocusoutEvent);
      }

      _submitForm() {
        const form = this.closest('form');
        if (form) {
          form.submit();
        }
      }

      _hideList() {
        this.popoutList.classList.remove('popout-list--visible', 'popout-list--top');
        this.popoutToggle.setAttribute('aria-expanded', false);
        document.body.removeEventListener('click', this.bodyClickEvent);
      }
    }
  );
}
